import { useAppConstantsContext } from '@/context/AppConstants';
import { Button, styled } from '@/theme/index';
import { useScreenSize } from '@/utils/useScreenSize';
import { INSTRUCTIONAL_VIDEO, InstructionalProps } from './constants';

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  width: '290px',
  [theme.breakpoints.up('sm')]: {
    width: '170px',
  },
}));

const VideoContainer = styled('div')(({ theme }) => ({
  width: '292px',
  height: '250px',
  overflow: 'hidden',
  border: `2px solid ${theme.palette.grey[300]}`,
  [theme.breakpoints.up('sm')]: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  [theme.breakpoints.up('lg')]: {
    width: '1092px',
  },
}));

const StyledVideo = styled('video')(({ theme }) => ({
  clipPath: 'inset(3px 0px 3px 0px)',
  height: '250px',
  marginTop: '-2px',
  [theme.breakpoints.up('sm')]: {
    border: `2px solid ${theme.palette.grey[300]}`,
    width: '100%',
    height: '100%',
    clipPath: 'none',
    marginTop: '0',
  },
  [theme.breakpoints.up('lg')]: {
    width: '1092px',
  },
}));

/**
 * This component lives in the QuestionsSurvey aka Onboarding Questions(DQS),
 * it's being rendered when the input_type is instructional or instructional_video.
 *
 * This question doesn't store anything, if component is instructional it will show a thanks message.
 * If component is instructional_video it will show a video.
 */
export const OnboardingInstructional = ({
  screenId,
  customAttribute,
  storeAnswer,
  inputType,
}: InstructionalProps) => {
  return (
    <Container>
      {inputType == INSTRUCTIONAL_VIDEO && <InstructionalVideo />}
      <StyledButton
        color="primary"
        variant="contained"
        onClick={() =>
          storeAnswer({
            screen_id: screenId,
            custom_attribute: customAttribute,
            response: null,
          })
        }
      >
        Go to Report
      </StyledButton>
    </Container>
  );
};

const InstructionalVideo = () => {
  const { isMobile } = useScreenSize();
  const {
    links: { instructionalVideoMobile, instructionalVideoDesktop },
  } = useAppConstantsContext();

  return (
    <VideoContainer>
      <StyledVideo
        autoPlay
        controls
        muted
        loop
        playsInline
        src={isMobile ? instructionalVideoMobile : instructionalVideoDesktop}
        data-testid="instructional-video"
      />
    </VideoContainer>
  );
};
